import Vue from "vue"
import { Line } from "vue-chartjs/legacy"
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels"

let selectedItemCodes = []
let isHideNoCheck = false

const getOrCreateLegendList = (id) => {
  const legendContainer = document.getElementById(id)
  let listContainer = legendContainer.querySelector('ul')

  if (!listContainer) {
    listContainer = document.createElement('ul')
    listContainer.style.display = 'flex'
    listContainer.style.flexDirection = 'row'
    listContainer.style.flexWrap = 'wrap'
    listContainer.style.margin = 0
    listContainer.style.padding = 0

    legendContainer.appendChild(listContainer)
  }

  return listContainer
};

const getOrCreateCheck = (id) => {
  const checkContainer = document.getElementById(id)
  let boxContainer = checkContainer.querySelector('div')

  if (!boxContainer) {
    boxContainer = document.createElement('div')
    boxContainer.className = 'custom-control custom-checkbox'
    checkContainer.appendChild(boxContainer)
  }

  return boxContainer
}

const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate: (chart, args, options) => {
    if (options.isChartInit) {
      selectedItemCodes = []
      isHideNoCheck = false
    }
    if (options.isChartSlide) {
      const items = chart.options.plugins.legend.labels.generateLabels(chart)
      items.forEach(item => {
        if (!selectedItemCodes.includes(chart.data.datasets[item.datasetIndex].label[0])) {
          chart.data.datasets[item.datasetIndex].borderWidth = 3
          chart.data.datasets[item.datasetIndex].datalabels.display = 'auto';
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 14
          chart.data.datasets[item.datasetIndex].datalabels.padding = 5
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 15
          if (isHideNoCheck) {
            chart.setDatasetVisibility(item.datasetIndex, false)
          } else {
            chart.setDatasetVisibility(item.datasetIndex, true)
          }
        } else {
          chart.data.datasets[item.datasetIndex].borderWidth = 6
          chart.data.datasets[item.datasetIndex].datalabels.display = true;
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 18
          chart.data.datasets[item.datasetIndex].datalabels.padding = 6
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 19
          chart.setDatasetVisibility(item.datasetIndex, true)
        }
      })
    }

    const check = getOrCreateCheck('check-container')

    while (check.firstChild) {
      check.firstChild.remove()
    }

    const input = document.createElement('input')
    input.id = 'is_hide_no_check'
    input.type='checkbox';
    input.className = 'custom-control-input'
    input.checked = isHideNoCheck
    input.onclick = () => {
      isHideNoCheck = !isHideNoCheck
      const items = chart.options.plugins.legend.labels.generateLabels(chart)
      items.forEach(item => {
        if (!selectedItemCodes.includes(chart.data.datasets[item.datasetIndex].label[0])) {
          chart.data.datasets[item.datasetIndex].borderWidth = 3
          chart.data.datasets[item.datasetIndex].datalabels.display = 'auto';
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 14
          chart.data.datasets[item.datasetIndex].datalabels.padding = 5
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 15
          if (isHideNoCheck) {
            chart.setDatasetVisibility(item.datasetIndex, false)
          } else {
            chart.setDatasetVisibility(item.datasetIndex, true)
          }
        } else {
          chart.data.datasets[item.datasetIndex].borderWidth = 6
          chart.data.datasets[item.datasetIndex].datalabels.display = true;
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 18
          chart.data.datasets[item.datasetIndex].datalabels.padding = 6
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 19
          chart.setDatasetVisibility(item.datasetIndex, true)
        }
      })
      chart.update()
    }
    const label = document.createElement('label')
    label.setAttribute('for', 'is_hide_no_check')
    label.className = 'custom-control-label'
    label.textContent = 'チェックした商品のみ表示'

    check.appendChild(input)
    check.appendChild(label)

    const ul = getOrCreateLegendList(options.containerID)

    while (ul.firstChild) {
      ul.firstChild.remove()
    }

    const items = chart.options.plugins.legend.labels.generateLabels(chart)

    items.forEach(item => {
      const li = document.createElement('li')
      li.style.alignItems = 'center'
      li.style.cursor = 'pointer'
      li.style.display = 'flex'
      li.style.flexDirection = 'row'
      li.style.marginRight = '10px'
      li.style.marginBottom = '10px'
      li.setAttribute('data-toggle', 'tooltip')
      li.className = 'yseo-graph-legend-item'
      li.title = item.text[1]

      li.onclick = () => {
        // chart.setDatasetVisibility(itecibm.datasetIndex, !chart.isDatasetVisible(item.datasetIndex))
        if (selectedItemCodes.includes(chart.data.datasets[item.datasetIndex].label[0])) {
          chart.data.datasets[item.datasetIndex].borderWidth = 3
          chart.data.datasets[item.datasetIndex].datalabels.display = 'auto';
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 14
          chart.data.datasets[item.datasetIndex].datalabels.padding = 5
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 15
          selectedItemCodes = selectedItemCodes.filter((value, index, array) => {
            return value !== chart.data.datasets[item.datasetIndex].label[0]
          })
          if (isHideNoCheck) {
            chart.setDatasetVisibility(item.datasetIndex, false)
          } else {
            chart.setDatasetVisibility(item.datasetIndex, true)
          }
        } else {
          chart.data.datasets[item.datasetIndex].borderWidth = 6
          chart.data.datasets[item.datasetIndex].datalabels.display = true;
          chart.data.datasets[item.datasetIndex].datalabels.borderRadius = 18
          chart.data.datasets[item.datasetIndex].datalabels.padding = 6
          chart.data.datasets[item.datasetIndex].datalabels.labels.value.font.size = 19
          selectedItemCodes.push(chart.data.datasets[item.datasetIndex].label[0])
          chart.setDatasetVisibility(item.datasetIndex, true)
        }
        $('.yseo-graph-legend-item').tooltip('hide')
        chart.update()
      };

      const boxSpan = document.createElement('span')
      boxSpan.style.background = item.fillStyle
      boxSpan.style.borderColor = item.strokeStyle
      boxSpan.style.borderWidth = item.lineWidth + 'px'
      boxSpan.style.display = 'inline-block'
      boxSpan.style.height = '20px'
      boxSpan.style.marginRight = '5px'
      boxSpan.style.width = '20px'
      boxSpan.style.borderRadius = '3px'
      boxSpan.style.backgroundImage = selectedItemCodes.includes(chart.data.datasets[item.datasetIndex].label[0]) ? 'url(/img/check.png)' : 'none'
      boxSpan.style.backgroundRepeat = 'no-repeat'
      boxSpan.style.backgroundPoisition = '50% 50%'
      boxSpan.style.backgroundSize = 'contain'

      const textContainer = document.createElement('p')
      textContainer.style.color = item.fontColor
      textContainer.style.margin = 0
      textContainer.style.padding = 0

      const text = document.createTextNode(item.text[0])
      textContainer.appendChild(text)

      li.appendChild(boxSpan)
      li.appendChild(textContainer)
      ul.appendChild(li)

    });

    $('.yseo-graph-legend-item').tooltip()
  }
};

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  ChartDataLabels,
  htmlLegendPlugin
)

Vue.component("LineChart", {
  extends: Line,
})
